export const QUERY_CLIENT_SETTINGS = {
  defaultOptions: {
    queries: {
      staleTime: 15e3,
    },
  },
};
